import { NgModule } from '@angular/core';
import { CART_IMPORT_EXPORT_FEATURE } from '@spartacus/cart/import-export/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        [CART_IMPORT_EXPORT_FEATURE]: {
          cmsComponents: [
            'ImportExportOrderEntriesComponent',
            'ImportOrderEntriesComponent',
            'ExportOrderEntriesComponent',
          ],
        },
      },
    }),
  ],
})
export class CustomImportExportRootModule {}
